<template>
  <component :is="as" :class="classes" :rel="rel" v-on="$listeners">
    <slot />
  </component>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';

export default {
  name: 'ECard',
  mixins: [classes],
  props: {
    as: {
      type: String,
      default: 'div',
      cssClass: true,
    },
    elevation: {
      type: Number,
      default: 1,
      cssClass: true,
    },
    overflowVisible: {
      type: Boolean,
      default: false,
      cssClass: true,
    },
  },
  computed: {
    rel() {
      return this.as === 'a' ? 'noopener' : undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  @include elevation(1);

  display: block;
  border-radius: $border-radius-l;
  overflow: hidden;
}

.card--elevation-0 {
  @include elevation(0);
}

.card--as-button {
  appearance: none;
  cursor: pointer;
}

.card--as-a,
.card--as-button {
  background-color: var(--color-background-primary);
  transition-property: background;
  transition-duration: $timing-2s;
  transition-timing-function: $easing;

  &:hover {
    background-color: var(--color-button-background-secondary-hover);
  }

  &:focus {
    @extend %keyboard-nav-focus;

    outline-offset: 0;
  }
}

.card--overflow-visible {
  overflow: visible;
}
</style>
